import { create } from 'zustand';
import { onSessionChange } from './session-read';

/**
 * Global guest-upgrade prompt (single instance, mounted in app.tsx — same pattern as
 * UpgradePromptModal). The convention:
 *   - a gated PAGE renders GuestWall (full-page, navbar intact);
 *   - a gated in-page ACTION opens this modal (keeps the user's context).
 * Both share the same visual language: lock icon, pitch, "Create a free account".
 */
interface GuestUpgradeState {
  isOpen: boolean;
  title: string;
  description: string;
  open: (opts: { title: string; description: string }) => void;
  close: () => void;
}

export const useGuestUpgradeStore = create<GuestUpgradeState>((set) => ({
  isOpen: false,
  title: '',
  description: '',
  open: ({ title, description }) => set({ isOpen: true, title, description }),
  close: () => set({ isOpen: false }),
}));

// The guest's sign-up prompt closes once a session begins (#940).
onSessionChange(() => useGuestUpgradeStore.getState().close());
